import { z as zod } from 'zod';

export const WhatsAppNumberFormSchema = zod.object({
  id: zod.number().optional(),
  name: zod.string().nonempty({
    message: 'O campo nome é obrigatório e não pode estar vazio.',
  }),
  phoneNumber: zod
    .string()
    .nonempty({
      message:
        'O campo número de celular é obrigatório e não pode estar vazio.',
    })
    .regex(/^\(\d{2}\) \d{1} \d{4}-\d{4}$/, {
      message: 'O número de celular deve estar no formato (XX) X XXXX-XXXX.',
    }),
});
